export default __webpack_public_path__ + "static/media/mobile-phone.efdf9611.png";